module.exports = __webpack_public_path__ + "img/avatar-s-11.4799a585.png";